export default __webpack_public_path__ + "f363d4ad04e0a76155b5d1ae44e5820c.svg";